export default __webpack_public_path__ + "static/media/alarm.d3cd3d61.svg";